import {Api} from '@settings/api'

export const PIN_GLOBAL_MEASUREMENT_NAME_KEY = 'pinGlobalMeasurementName'

type PinGlobalMeasurementNameParameters = {keyIdentifier: string; value: string}

export async function pinGlobalMeasurementName({
  keyIdentifier,
  value
}: PinGlobalMeasurementNameParameters): Promise<void> {
  const path = '/distributeduserstorage'
  await Api.axiosInstance.post(path, {
    keyIdentifier,
    value
  })
}
